/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentWorkflowTemplateVisibleIn {
    INVESTMENT_WORKFLOWS_BUYING = 'INVESTMENT_WORKFLOWS_BUYING',
    INVESTMENT_WORKFLOWS_SELLING = 'INVESTMENT_WORKFLOWS_SELLING',
    NON_INVESTMENT_WORKFLOWS = 'NON_INVESTMENT_WORKFLOWS',
    KYC_INDIVIDUAL = 'KYC_INDIVIDUAL',
    KYC_VEHICLE = 'KYC_VEHICLE',
}
